import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FiMessageSquare } from "react-icons/fi";

// Background image imported and applied strictly in JSX inline style
import bgCtaRibbon from '../assets/prisoners.jpg';

export default function CallToAction(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <section 
                className="MainBodySection mwadeo-cta-wrapper position-relative"
                style={{ backgroundImage: `url(${bgCtaRibbon})` }}
            >
                {/* Strictly Dark Color Overlay */}
                <div className="cta-overlay"></div>

                <div className="container position-relative z-index-2">
                    <div className="cta-content-wrapper">
                        
                        {/* Left Side: Punchy Core Statement */}
                        <div className="cta-text-block">
                            <div className="cta-accent-line"></div>
                            <h3 className="title-font-semi-bold cta-heading">
                                Ready to Make a Difference?
                            </h3>
                            <p className="font-regular cta-subtext">
                                Whether you want to volunteer, donate, or collaborate, your support drives 
                                sustainable change and empowers communities across Tanzania.
                            </p>
                        </div>

                        {/* Right Side: Premium Action Trigger */}
                        <div className="cta-action-block">
                            <button 
                                className="btn btn-mwadeo-cta title-font-semi-bold"
                                onClick={() => appContext.navTo({ item: 'contact_us' })}
                            >
                                <span>Contact Us Today</span>
                                <FiMessageSquare size={16} />
                            </button>
                        </div>

                    </div>
                </div>
            </section>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "120px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}